import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getToken, getUser } from "../utils/Common";
import { RadioButton } from 'primereact/radiobutton';

export const Home = () => {
  let navigate = useNavigate();
  let polaznikUpper = sessionStorage.getItem("polaznik");
  let ustanovaNazivUpper = sessionStorage.getItem("nazivUstanove");
  let razredi = [];
  if ( sessionStorage.getItem("tekuciRazred") !== null && sessionStorage.getItem("tekuciRazred") === '1') razredi = [{name: '1.', key: '1'}];
  else if ( sessionStorage.getItem("tekuciRazred") !== null && sessionStorage.getItem("tekuciRazred") === '2') razredi = [{name: '1.', key: '1'}, {name: '2.', key: '2'}];
  else if ( sessionStorage.getItem("tekuciRazred") !== null && sessionStorage.getItem("tekuciRazred") === '3') razredi = [{name: '1.', key: '1'}, {name: '2.', key: '2'}, {name: '3.', key: '3'}];
  else razredi = [{name: '1.', key: '1'}, {name: '2.', key: '2'}, {name: '3.', key: '3'}, {name: '4.', key: '4'}];

  //const razredi = [{name: '1.', key: '1'}, {name: '2.', key: '2'}, {name: '3.', key: '3'}, {name: '4.', key: '4'}];

  useEffect(() => {
    if (
      getUser() === null ||
      polaznikUpper === "undefined" ||
      getToken() === null
    ) {
      navigate("/login");
    }
    if (sessionStorage.getItem("razredPregleda") > 4 ) sessionStorage.setItem("razredPregleda", 4);
  }, [navigate, polaznikUpper]);

  return (
    <div className="centerText">
      <h4>
        <p className="welcome-polaznik">{polaznikUpper},</p>
        <p className="welcome-ustanova">{ustanovaNazivUpper}</p>
        <p className="welcome-message">dobro došli u sustav e-Dnevnik!</p>
        <br/>
        <p className="welcome-message">Odaberite razred za koji želite pregledati podatke:</p>
        {
          razredi.map((razredi) => {
            return (
                <div key={razredi.key} className="field-radiobutton centerRadio">
                    <RadioButton 
                        inputId={razredi.key} 
                        name="razredi" 
                        value={razredi.key} 
                        onChange={(e) => {
                                    sessionStorage.setItem("razredPregleda", razredi.key)
                                    navigate("/")
                      }}  
                      checked={sessionStorage.getItem("razredPregleda") === razredi.key} />
                    <label htmlFor={razredi.key}>{razredi.name}</label>
                </div>
            )
          })
        }
      </h4>
    </div>
  );
};

export default Home;
